/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const InfoIcon = createIcon({
  displayName: "InfoIcon",
  viewBox: "0 0 14 14",
  path: (
    <g fill="none" stroke="currentColor" strokeWidth={1.25}>
      <circle
        cx={7}
        cy={7}
        r={5.375}
        stroke="currentColor"
        strokeWidth={1.25}
      />
      <path
        d="M8.6752 3.5H7.0752L6.7002 5H8.3002L8.6752 3.5Z"
        fill="currentColor"
      />
      <path
        d="M8.0502 6H6.4502L5.3252 10.5H6.9252L8.0502 6Z"
        fill="currentColor"
      />
    </g>
  )
});
